import Input from "~/components/Backroom/Input";
import ButtonGroup from "../ButtonGroup";
import { CurrentStepProps } from "../getSideMenuItems";
import { stringToCurrency } from "~/utils/stringConversion";
import { DeliveryInputs } from "./DeliveryInputs";
import { Inputs } from "../useUpsertProductForm";
import { OfferInputs } from "./OfferInputs";
import { useUserQuery } from "~/api/user";

export const pricePreviewImages = [
  {
    id: "price1",
    title: "Vist på produktsiden",
    src: "/assets/images/previews/products/product-price/desktop.png",
    alt: "Placering af prisen på produktsiden",
    width: 340,
    height: 420,
  },
  {
    id: "price2",
    title: "Vist på produktsiden på mobil",
    src: "/assets/images/previews/products/product-price/mobil.png",
    alt: "Placering af prisen på produktsiden på mobil",
    width: 200,
    height: 500,
  },
  {
    id: "price3",
    title: "Vist på produktoverbliksiden",
    src: "/assets/images/previews/products/product-price/desktop2.png",
    alt: "Placering af prisen på produktoverbliksiden",
    width: 340,
    height: 420,
  },
  {
    id: "price4",
    title: "Vist på produktoverbliksiden på mobil2",
    src: "/assets/images/previews/products/product-price/mobil.png",
    alt: "Placering af prisen på produktoverbliksiden på mobil",
    width: 200,
    height: 500,
  },
];

export const FIELDS: Array<keyof Inputs> = [
  "price",
  "canOnlyBePickedUp",
  "coveredByStoreDeliveryPrice",
  "deliveryPrice",

  "weightInGrams",
  "followsShipmondoGuidelines",

  "hasOffer",
  "offerPrice",
  "offerTitle",
  "offerStartDate",
  "offerEndDate",
  "offerIsLegal",
];

export const PriceStep = (props: CurrentStepProps) => {
  const { data } = useUserQuery();
  const { stepId, form, onContinue, isSubmitting, isEditing, onStepChange } =
    props;
  const {
    register,
    trigger,
    formState: { errors },
    reset,
    getValues,
    setError,
    clearErrors,
  } = form;

  const beforeContinue = async (options?: { shouldExitEditing?: boolean }) => {
    let isValid = await trigger(FIELDS);

    // If the product is set to be shipped with Shipmondo,
    // the user must take a stance on whether the product follows Shipmondo's guidelines
    if (data?.store.deliveryType === "shipmondo") {
      const { followsShipmondoGuidelines, canOnlyBePickedUp } = getValues();
      if (followsShipmondoGuidelines === undefined && !canOnlyBePickedUp) {
        setError("followsShipmondoGuidelines", {
          type: "manual",
          message:
            "Du skal tage stilling til, om produktet følger Shipmondo's retningslinjer.",
        });
        isValid = false;
      } else {
        clearErrors("followsShipmondoGuidelines");
      }
    }

    if (isValid) {
      onContinue(stepId, {
        visibleFields: FIELDS,
        shouldExitEditing: options?.shouldExitEditing,
      });
      // istanbul ignore next
      isEditing && reset({}, { keepValues: true });
    }
  };

  return (
    <>
      <h1 className="text-3xl mb-5">Produktdetaljer</h1>
      <p className="mb-12">
        I det følgende skal du specificere produktets pris og fragtdetaljer.
      </p>

      <Input
        id="price"
        label="Produktets pris:"
        placeholder="00,00"
        register={register}
        className="mb-12"
        error={errors.price}
        type="currency"
        registerOptions={{
          valueAsNumber: true,
          required: "Pris er påkrævet",
          max: {
            value: 999999,
            message: `Pris kan ikke være højere end ${stringToCurrency({
              amount: 999999,
            })}`,
          },
          min: {
            value: 1,
            message: `Pris kan ikke være lavere end ${stringToCurrency({
              amount: 1,
            })}`,
          },
        }}
      />

      <DeliveryInputs form={form} />

      <OfferInputs form={form} />

      <div className="flex flex-col-reverse lg:flex-col gap-12">
        <ButtonGroup
          isEditing={isEditing}
          onContinue={beforeContinue}
          onStepChange={onStepChange}
          form={form}
          stepId={stepId}
          isSubmitting={isSubmitting}
        />
      </div>
    </>
  );
};
